export const CONFIRMED_CREATE_SYMPTOM_ACTION = "CONFIRMED_CREATE_SYMPTOM_ACTION";
export const CONFIRMED_DELETE_SYMPTOM_ACTION = "CONFIRMED_DELETE_SYMPTOM_ACTION";
export const CONFIRMED_EDIT_SYMPTOM_ACTION = "CONFIRMED_EDIT_SYMPTOM_ACTION";
export const CONFIRMED_GET_SYMPTOMS = "CONFIRMED_GET_SYMPTOMS";
